import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowRight, Zap, Repeat, Hammer, Home as HomeIcon, TrendingUp, Building2, Landmark, Briefcase } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PROGRAMS, PROGRAM_ORDER } from "@/data/site";
import { ProgramCard } from "@/components/site/ProgramCard";

const icons = { "fix-and-flip": Hammer, "dscr-rental": HomeIcon, bridge: TrendingUp, "ground-up-construction": Building2, multifamily: Landmark, portfolio: Briefcase };

export default function LoanPrograms() {
  const navigate = useNavigate();
  return (
    <div>
      <section className="border-b border-edge grain-bg">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16 lg:py-20">
          <div className="eyebrow mb-3">Loan Programs</div>
          <h1 className="h-display text-4xl sm:text-5xl lg:text-6xl text-white max-w-3xl">Financing built around the deal.</h1>
          <p className="mt-4 text-dim max-w-xl">Explore financing across eight investment strategies. Submit a deal and we'll help match it to the right structure.</p>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {PROGRAM_ORDER.map((slug) => (
            <ProgramCard key={slug} slug={slug} title={PROGRAMS[slug].title} desc={PROGRAMS[slug].short} Icon={icons[slug]} />
          ))}
          <ProgramCard slug="emd-funding" eyebrow="Need EMD?" title="EMD Funding" desc="Short-term earnest money deposit funding for qualified investment transactions." Icon={Zap} accent="gold" fundLabel="Get EMD Funding" onFund={() => navigate("/emd-funding")} />
          <ProgramCard slug="transactional-funding" eyebrow="Need a Double Close Funded?" title="Transactional Funding" desc="Short-duration capital for qualified A-B / B-C double closings." Icon={Repeat} accent="red" fundLabel="Get Funding" onFund={() => navigate("/transactional-funding")} />
        </div>
      </section>
    </div>
  );
}
